export type ContractSearchState = {
  contractSearchString?: string | number | null;
  number?: string | number | null;
};

export function resolveContractSearchTerm(
  contractSearch?: ContractSearchState | null,
  completionQuery?: string | number | null
): string {
  if (completionQuery !== null && completionQuery !== undefined) {
    return String(completionQuery).trim();
  }

  const currentInput = contractSearch?.contractSearchString;

  if (currentInput !== null && currentInput !== undefined) {
    return String(currentInput).trim();
  }

  return String(contractSearch?.number ?? "").trim();
}
